import FollowUpHero from "./components/FollowUpHero";
import FollowUpContext from "./components/FollowUpContext";
import FollowUpStrategy from "./components/FollowUpStrategy";

const FollowUp = () => {
  return (
    <>
      <FollowUpHero />
      <FollowUpContext />
      <FollowUpStrategy />
    </>
  );
};

export default FollowUp;
